const name = 'Rotate';
const properties = {
    groups: ['animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        from: {
            type: 'object',
            properties: {
                rotation: {
                    type: 'number',
                },
            },
        },
        to: {
            type: 'object',
            properties: {
                rotation: {
                    type: 'numberLike',
                    default: 360,
                },
                direction: {
                    type: 'string',
                    enum: ['cw', 'ccw', 'short'],
                },
            },
        },
    },
};
/**
 * Rotate animation object
 * Defaults to rotate 360 deg with Cubic.easeIn
 */
function animate(kit, elements, duration, delay, { from = {}, to = {}, ease = 'Sine.easeIn', ...params } = {}) {
    const sequence = kit.sequence(params);
    to.rotation = to.rotation || properties.schema.to.properties.rotation.default;
    sequence.add(kit.animate('BaseRotate', elements, duration, delay, {
        from,
        to,
        ease,
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=rotate.js.map